/**
 * ComputeIndexCTA — small inline call-to-action shown next to (or in place of)
 * a missing index. Lets the user navigate directly to the tool that computes
 * the index, so they're never stuck looking at "—".
 *
 * Usage:
 *   <ComputeIndexCTA
 *     value={signals.nis_avg}
 *     route="/dashboard/diary"
 *     label="Изчисли NIS"
 *     testid="compute-nis"
 *   />
 *
 * If `value` is truthy / non-empty, renders nothing (the actual index is shown).
 */
import React from "react";
import { Link } from "react-router-dom";
import { Calculator, ArrowUpRight } from "lucide-react";

export default function ComputeIndexCTA({
  value,
  route,
  label_bg = "Изчисли сега",
  label_en = "Compute now",
  lang = "bg",
  testid,
  isDark = false,
  size = "sm",
}) {
  const isMissing =
    value === null || value === undefined || value === "" || value === "—" || Number.isNaN(value);
  if (!isMissing) return null;
  const bg = lang === "bg";
  const px = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]";
  return (
    <Link
      to={route}
      data-testid={testid || "compute-index-cta"}
      className={`inline-flex items-center gap-1 rounded-full font-semibold transition-all hover:scale-[1.02] ${px} ${
        isDark
          ? "bg-cyan-500/15 text-cyan-200 hover:bg-cyan-500/25 border border-cyan-500/30"
          : "bg-cyan-50 text-cyan-700 hover:bg-cyan-100 border border-cyan-200"
      }`}
    >
      <Calculator className="w-3 h-3" />
      <span>{bg ? label_bg : label_en}</span>
      <ArrowUpRight className="w-2.5 h-2.5 opacity-70" />
    </Link>
  );
}
